/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Scope_BrokersInputs */

const cs_ebr_scope_brokers = /** @type {(inputs: Ebr_Scope_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen makléři`)
};

const en_ebr_scope_brokers = /** @type {(inputs: Ebr_Scope_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers only`)
};

/**
* | output |
* | --- |
* | "Brokers only" |
*
* @param {Ebr_Scope_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_scope_brokers = /** @type {((inputs?: Ebr_Scope_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Scope_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_scope_brokers(inputs)
	return cs_ebr_scope_brokers(inputs)
});